<template>
<div>
  <modal modalClasses="modal-full"  size="lg" :show.sync="showModal">
    <h6 slot="header" class="modal-title">Crear Subcategoría</h6>
    <form class="needs-validation" id="formCreateSubcategory"
        @submit.prevent="sendForm">
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre"
                      placeholder="Ingrese un nombre"
                      name="nombre"
                      :error="getError('nombre')"
                      v-validate="'required'"
                      v-model="model.name">
          </base-input>
        </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Categoria"
                      name="categoria"
                      :error="getError('categoria')"
                      v-validate="'required'"
                      v-model="model.category.value"
                >
                    <el-select  v-model="model.category.value" filterable
                                placeholder="Seleccione categoría"
                                
                                >
                        <el-option v-for="option in selectCategories"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
            <card>
                <div class="row ">
                    <div class="col col-md-6 d-flex justify-content-center">
                        <base-input label="Asociar campos:" >
                            <!--<input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="button-addon2">-->
                            <el-select @change="refreshFeatures"  v-model="chosenFields" multiple collapse-tags
                                        placeholder="Seleccione los campos">
                                <el-option v-for="option in selectSearchablesAttributes"
                                            :key="option.label"
                                            :label="option.label"
                                            :value="option.value">
                                </el-option>
                            </el-select>
                        </base-input>
                    </div>
                    <div class="col col-md-6 d-flex align-content-center flex-wrap">
                        <button class=" btn btn-default" type="button" @click="abrirModalCreateSearchableAtribute('create')"><i class="ni ni-curved-next"></i> Crear campo</button>
                    </div>
                </div>
                <div class="row">
                    <p class="lead" style="margin-bottom: 0px">
                        Estos son los campos que se solicitarán al momento de la búsqueda de los planes asociados a esta subcategoría, para encontrar precisamente el plan adecuado a los datos ingresados en dichos campos.
                    </p>
                </div>
                <div class="row">
                    <div class="table-responsive">
                        <base-table class="table  mt-5"
                                    :data="features">
                            <template slot="columns">
                                <th class="text-center px-0 bg-transparent" scope="col">
                                <span class="text-light font-weight-700">Campo</span>
                                </th>
                                <th class="text-center bg-transparent" scope="col">Nombre público </th>
                                <th class="text-center bg-transparent" scope="col">Tipo de Campo </th>
                                <th class="text-center bg-transparent" scope="col">Tipo de Dato</th>
                                <th class="text-center bg-transparent" scope="col">Opciones de Datos</th>
                            </template>
                            
                            <template slot-scope="{row}">
                                <td class="text-center px-0">{{row.campo}}</td>
                                <td class="text-center" v-html="row.nombre_publico"></td>
                                <td class="text-center" v-html="row.tipo_campo"></td>
                                <td class="text-center" v-html="row.tipo_dato"></td>
                                <td class="text-center" v-html="row.opciones_dato"></td>
                            </template>
                            
                        </base-table>
                    </div>
                </div>
            </card>
        </div>
      </div>
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formCreateSubcategory">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>
    
  </modal>
  
  
  </div>
</template>
<script>
  import BaseTable from '@/components/BaseTable';
  
  import AppendSearchableAttribute from '@/views/Subcategories/AppendSearchableAttribute.vue';
  import { Select, Option } from 'element-ui';
  export default {
    components: {
        BaseTable,
        AppendSearchableAttribute,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
      return {
        validated: false,
        model: {
          name: '',
          category: {},
        },
        showModal: false,
        chosenFields: [],
        
        features: [],
        selectCategories: [],
        selectSearchablesAttributes: [],
        //selectSearchablesAttributesMirror : []
      }
    },
    methods: {
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          
          this.validated = true;
        }
      },
      abrirModalCreateSearchableAtribute(from){
        this.showModal = false;
        this.$emit('showModalCreateSearchableAtribute', from);
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      fetchSearchablesAttributesList(){
          var vm = this;
          this.axios({
              url: 'api/fetch_searchables_attributes_list_from_create_subcategory',
              method: 'GET',
          })
          .then( response => {
              vm.selectSearchablesAttributes = response.data;
          })
          .catch( error => {
              console.log(error);
          })
          ;
      },
      refreshFeatures(){
          this.features = [];
          let vm = this;
          this.chosenFields.forEach( id => {
              let aidi = id;
              vm.features.push( vm.selectSearchablesAttributes.find( elem => 
                elem.obj.id == aidi
              ).obj );
          });
      },
      sendForm(){
        var vm = this;
        
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          if( response ){
            
            vm.axios({
                method: 'POST',
                url: 'api/store_create_subcategory',
                data: {   
                        nombre: vm.model.name,
                        categoria: vm.model.category.value,
                        campos: vm.chosenFields 
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Subcategoría creada exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo almacenar la subcategoría',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
        }).catch( reason => {
          console.log(reason);
        });
        
      },
    },
    created()
    {
        this.$parent.$on('showModalCreateSubcategory', () => {
            this.showModal = false; 
            this.showModal = true; 
            this.fetchSearchablesAttributesList();
        });
    },
    mounted()
    {
        var vm = this;
        this.axios({
            method: 'GET',
            url: 'api/test_list_categories_from_create_subcategory'
        }).then(response => {
            vm.selectCategories = response.data;

        }).catch( error => {
            console.log(error);
        })
        ;
    },
  }
</script>
<style lang="scss">
  .modal-full{
    max-width: 1300px;
  }
</style>
